var fb_ready = false,
    fb_shared = false;

var fb_callback = function() {
    fb_ready = true;
};


jQuery(document).ready(function($) {

    var $share_button = jQuery("#mp-share-button");

    $share_button.on("click", function(e) {
        if ( fb_ready )
        {
            var url = $(this).data("share-url");

            FB.ui({
                method: "share",
                href: url
            }, function(response) {
                if (response) {
                    $share_button.fadeOut();
                }
            });

            e.preventDefault();
        }
    });

    $(".slick-for").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".slider-nav"
    });

    $(".slider-nav").slick({
        lazyLoad: "ondemand",
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        centerPadding: '250px',

        asNavFor: '.slick-for',
        dots: false,
        //centerMode: true,
        focusOnSelect: true,
        prevArrow: '<span class="slick-prev2"></span>',
        nextArrow: '<span class="slick-next2"></span>',

        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                    dots: true,
                }
            }
        ]
    });

    $('.slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<span class="slick-prev2"></span>',
        nextArrow: '<span class="slick-next2"></span>',
        responsive: [
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    centerMode: true,
                    variableWidth: true,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.slideris').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        variableWidth: true,
        slidesToScroll: 1,
        prevArrow: '<span class="slick-prev2"></span>',
        nextArrow: '<span class="slick-next2"></span>',
        responsive: [
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    centerMode: true,
                    variableWidth: true,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    variableWidth: true,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    /**
     * Super Sidekick
     * @returns {TimelineMax}
     */
    function sgirl() {
        var tl = new TimelineMax(),
            pan1 = $('.pan-1'),
            pan2 = $('.pan-2'),
            pan3 = $('.pan-3'),
            sgirl0 = $('.sgirl0'),
            sgirl1 = $('.sgirl1'),
            sgirl2 = $('.sgirl2'),
            sgirl3 = $('.sgirl3');

        sgirl1.hide();
        sgirl2.hide();

        // tl.fromTo( sgirl, 2, {x: -1000, y: 600}, {delay: 5, ease:  SlowMo.ease.config(0.7, 0.7, false), x: 0, y: 0}, 0.2);
        tl.staggerFrom( sgirl0, 5, {delay: 2, x: -1000, y: 650, onComplete: sComplete}, 0.2 );
        tl.staggerFrom( sgirl3, 3, {x: 1000, y: 650, onComplete: skComplete}, 0.1 );

        // pan1.show();
        tl.staggerFrom( pan1, 0.6, { delay: 1, opacity: 0} );
        tl.staggerFrom( pan2, 0.6, { delay: 0, opacity: 0} );
        tl.staggerFrom( pan3, 0.6, { delay: 0, opacity: 0} );

        function sComplete() {
            sgirl0.hide('slow');
            sgirl1.show('slow');

            tl.staggerTo([sgirl1, sgirl2], 1.3, {
                delay: 0,
                y: "+=10px",
                yoyo: true,
                repeat: -1,
                ease: Sine.easeInOut
            });
        }
        function skComplete() {
            sgirl3.hide('slow');
            sgirl2.show('slow');
        }


        return tl;
    }
    var $browserDetect = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if( !$browserDetect ) {
        if ($(window).width() > 768) {
            sgirl();
        }
    }


    var $countySelect = $("#county"),
        $neighbourhoodSelect = $("#neighbourhood");

    $countySelect.change(function() {
        var current_county = $countySelect.val();

        $neighbourhoodSelect.html("").append('<option value="" selected="selected">Select county first</option>');
        if(current_county != ""){
            $neighbourhoodSelect.html("");
            update_neighbourhoods(current_county, "");
        }
    });

    if ($countySelect.val() != "") {
        update_neighbourhoods($countySelect.val(), "<?php echo $user_data['neighbourhood'] ?>");
    } else {
        $neighbourhoodSelect.html("").append('<option value="" selected="selected">Select county first</option>');
    }

    function update_neighbourhoods(county, neighbourhood) {
        if (neighbourhood == "") {
            $neighbourhoodSelect.append('<option value="" selected="selected">Please select</option>');
        } else {
            $neighbourhoodSelect.append('<option value="">Please select</option>');
        }

        var values = neighbourhoods[county];
        $.each(values, function(key, item) {
            if (item == neighbourhood) {
                $neighbourhoodSelect.append('<option value="' + item + '" selected="selected">' + item + '</option>');
            } else {
                $neighbourhoodSelect.append('<option value="' + item + '">' + item + '</option>');
            }
        });
    }
});